import React from 'react';
import './ContactsPage.css';

const ContactsPage = () => {

  return (
    <div className="contacts-container">
      <h2>Contattaci</h2>
      <address className="contact-info">
        <p>
          <strong>Telefono:</strong>{' '}
          <a href="tel:+393341015507" className="contact-link" target="_blank" rel="noreferrer">
            3341015507
          </a>
        </p>
        <p>
          <strong>Email:</strong>{' '}
          <a href="mailto:antoniocilla@gmail.com" className="contact-link" target="_blank" rel="noreferrer">antoniocilla@gmail.com</a>
        </p>
        <p>
          <strong>Indirizzo:</strong> Via Sandro Pertini 24, Givoletto
        </p>
        <p>
          <strong>Facebook:</strong>{' '}
          <a href="https://it-it.facebook.com/antonio.cilla.566" className="contact-link" target="_blank" rel="noreferrer">Antonio Cilla</a>
        </p>
        <p>
          <strong>Instagram:</strong>{' '}
          <a href="https://www.instagram.com/cillaantonio/" className="contact-link" target="_blank" rel="noreferrer">cillaantonio</a>
        </p>
      </address>
    </div>
  );

};

export default ContactsPage;